export const updateName = (name) => (dispatch) => {
  dispatch({
    type: 'UPDATE_COLLECTIVE_CHECKIN_NAME',
    payload: name
  });
};

export const updateSelected = (id) => (dispatch, getState) => {
  dispatch({
    type: 'UPDATE_COLLECTIVE_CHECKIN_SELECTED',
    payload: getState().collective.checkin.selected === id ? 0 : id
  });
};

export const clearSelection = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_COLLECTIVE_CHECKIN_SELECTED'
  });
};
